const DEFAULT_SCHOOL_ID = '1';

const normalizeLegacyRoutePath = (path) => {
  if (typeof path !== 'string' || path.length === 0) {
    return path;
  }

  const trimmedPath = path.trim();
  const [pathname, search = ''] = trimmedPath.split('?');

  const normalizedPathname = (() => {
    switch (pathname) {
      case '/result':
      case 'result':
      case '/results':
      case 'results':
      case '/dashboard/results':
      case 'dashboard/results':
        return '/academic-results';
      default:
        return pathname;
    }
  })();

  return search ? `${normalizedPathname}?${search}` : normalizedPathname;
};

export const replaceSchoolIdPlaceholder = (path, schoolId) => {
  if (typeof path !== 'string' || path.length === 0) {
    return path;
  }

  const resolvedSchoolId = schoolId ? String(schoolId).trim() : DEFAULT_SCHOOL_ID;
  return normalizeLegacyRoutePath(
    path.split('{schoolId}').join(resolvedSchoolId || DEFAULT_SCHOOL_ID)
  );
};

const normalizeMenuItem = (item, schoolId) => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const text = item.text || item.title || '';
  return {
    ...item,
    text,
    title: item.title || text,
    path: replaceSchoolIdPlaceholder(item.path, schoolId),
  };
};

const isVisibleMenuPath = (path) => {
  if (typeof path !== 'string' || !path.trim()) {
    return true;
  }

  const [pathname] = path.trim().split('?');
  const segments = pathname.split('/').filter(Boolean).map((segment) => segment.toLowerCase());

  if (!segments.length) {
    return true;
  }

  if (segments.some((segment) => segment.startsWith(':'))) {
    return false;
  }

  const hiddenTerminalSegments = new Set(['new', 'edit', 'create', 'add', 'statistics']);
  return !hiddenTerminalSegments.has(segments[segments.length - 1]);
};

const dedupeItems = (items) => {
  const seen = new Set();
  const deduped = [];

  items.forEach((item) => {
    const key = `${item?.path || ''}|${item?.text || item?.title || ''}`;
    if (!seen.has(key)) {
      seen.add(key);
      deduped.push(item);
    }
  });

  return deduped;
};

export const normalizeMenuData = (rawMenuData = [], schoolId) => {
  if (!Array.isArray(rawMenuData)) {
    return [];
  }

  return rawMenuData
    .map((entry) => {
      if (!entry || typeof entry !== 'object') {
        return null;
      }

      const categoryItems = Array.isArray(entry.items)
        ? entry.items
          .map((item) => normalizeMenuItem(item, schoolId))
          .filter((item) => Boolean(item) && isVisibleMenuPath(item.path))
        : null;

      if (entry.isCategory || Array.isArray(entry.items)) {
        return {
          ...entry,
          isCategory: true,
          expandable: false,
          category: entry.category || entry.title || 'General',
          order: Number.isFinite(Number(entry.order)) ? Number(entry.order) : 999,
          items: dedupeItems(categoryItems || []),
        };
      }

      const normalizedSingle = normalizeMenuItem(entry, schoolId);
      if (!normalizedSingle) {
        return null;
      }
      if (!isVisibleMenuPath(normalizedSingle.path)) {
        return null;
      }

      return {
        ...normalizedSingle,
        isCategory: false,
      };
    })
    .filter(Boolean)
    .filter((entry) => {
      if (entry.isCategory) {
        return Array.isArray(entry.items) && entry.items.length > 0;
      }
      return Boolean(entry.text || entry.title);
    });
};
